// raised by Controllers to indicate that something has changed that
// required a description or URL change.  Such as clicking on
// an item from a list or adding a new record
export let EVENT_ROUTECHANGE: string = "routeChange";
export interface IRouteChange {
    appRouterID: string;
    url: string;
    title: string;
    subTitle: string;
    // newAppRouterID is used when a new record has been added
    // and the route ID needs to be changed.
    newAppRouterID?: string;
}

// raised by Controllers to indicate that the controller is closing
export let EVENT_ROUTECLOSE: string = "routeClose";
export interface IRouteClose {
    appRouterID: string;
}

// raised when a TargetTemplate is added or modified
export let EVENT_TARGETTEMPLATECHANGE: string = "targetTemplateChange";
export interface ITargetTemplateChange {
    targetTemplateID: number;
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--7!./src/script/common/eventUtil.ts